import Image from "next/image";
import Pill from "~/ui/pill";

export default function AdCard({ image, title, pills, price, onClick }) {
  return (
    <div className=" bg-gradient-to-r from-brand-primary via-yellow-300 to-yellow-500 rounded-lg p-1">
      <div
        className={`cursor-pointer relative rounded-lg  bg-brand-white`}
        onClick={onClick}
      >
        <div>
          <a className="select-text">
            <Image
              className="object-cover object-center rounded-t-md"
              src={image}
              width={640}
              height={480}
              alt="card cover image"
            />
          </a>
        </div>
        <div className="px-4 py-2 flex flex-col gap-2">
          <div>
            <div>
              <h3 className="font-medium cursor-pointer hover:underline text-xl select-text">
                {title}
              </h3>
            </div>
          </div>

          <div className="flex gap-1 flex-wrap">
            {pills.map((pill) => (
              <Pill key={pill}>{pill}</Pill>
            ))}
          </div>

          {price && (
            <p
              onClick={(e) => e.preventDefault()}
              className="text-xl font-medium"
              draggable={false}
            >
              $ Precio de tu auto
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
